import Vuex from 'vuex';

import { SentryVuexPlugin } from '@/plugins/sentry';
import { LoggerVuexPlugin } from '@/plugins/vuex/logger';
import { FlutterVuexPlugin } from '@/plugins/vuex/flutter';
import { EventHubVuexPlugin } from '@/plugins/vuex/eventHub';
import { HttpClientVuexPlugin } from '@/plugins/vuex/httpClient';
import { SoulodyClientVuexPlugin } from '@/plugins/vuex/soulodyClient.js';
import { AuthVuexPlugin } from '@/plugins/vuex/auth';
import { XApiTokenVuexPlugin } from '@/plugins/vuex/xApiToken';
import { RouterVuexPlugin } from '@/plugins/vuex/router';

import { aeskulab } from './aeskulab';
import { apiToken } from './apiToken';
import { auth } from './auth';
import { conference } from '@/feature/conference/store/conference';
import { cookiesConsent } from './cookiesConsent';
import { dynamicForms } from './dynamicForms';
import { errorModal } from './errorModal';
import { flutter } from './flutter';
import { forCompanies } from './forCompanies';
import { forms } from './forms';
import { general } from './general';
import { hrbPartner } from './hrbPartner';
import { legalDocuments } from './legalDocuments';
import { partnerNavigation } from './partnerNavigation';
import { profile } from './profile';
import { rsAssistant } from './rsAssistant';
import { sendButton } from './sendButton';
import { staticForms } from './staticForms';
import { thematicCounselling } from './thematicCounselling';
import { vitalSigns } from './vitalSigns';
import staticForm from './staticForm.js';
import { soulodyApi } from './soulodyApi.js';

const storeModules = {
  aeskulab,
  apiToken,
  auth,
  conference,
  cookiesConsent,
  dynamicForms,
  errorModal,
  flutter,
  forCompanies,
  forms,
  general,
  hrbPartner,
  legalDocuments,
  partnerNavigation,
  profile,
  rsAssistant,
  sendButton,
  staticForms,
  thematicCounselling,
  vitalSigns,
  staticForm,
  soulodyApi
};

export const createStore = () => {
  return new Vuex.Store({
    modules: storeModules,
    plugins: [
      SentryVuexPlugin,
      LoggerVuexPlugin,
      FlutterVuexPlugin,
      EventHubVuexPlugin,
      XApiTokenVuexPlugin,
      RouterVuexPlugin,
      HttpClientVuexPlugin,
      SoulodyClientVuexPlugin,
      AuthVuexPlugin
    ]
  });
};
